{{ 'Analysis::TrendAnalysis:ExportFailedNotificationMessage' | abpLocalization }}
